import React from "react";
import { ArrowLeft, Boxes, ShoppingCart, Wand2 } from "lucide-react";
import { Button } from "@/components/ui/button";

function SourceButton({ icon: Icon, title, description, onClick, disabled = false, badge = "" }) {
  return (
    <button
      type="button"
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      className={`flex h-full min-h-[150px] w-full gap-4 rounded-lg border bg-white p-5 text-left shadow-sm transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 ${
        disabled ? "cursor-not-allowed opacity-60" : "hover:border-blue-300 hover:bg-blue-50/40"
      }`}
    >
      <span className={`flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-md ${disabled ? "bg-gray-100 text-gray-500" : "bg-blue-50 text-blue-700"}`}>
        <Icon className="h-5 w-5" />
      </span>
      <span className="min-w-0">
        <span className="flex flex-wrap items-center gap-2">
          <span className="block text-lg font-semibold text-gray-900">{title}</span>
          {badge && <span className="rounded-full border bg-gray-50 px-2 py-0.5 text-xs font-medium text-gray-600">{badge}</span>}
        </span>
        <span className="mt-2 block text-sm leading-6 text-gray-600">{description}</span>
      </span>
    </button>
  );
}

export function SimulationMagicSourceSelector({ onCancel, onSelectSales, onSelectAlfatex }) {
  return (
    <div className="space-y-4">
      <div className="rounded-lg border bg-white p-4 shadow-sm">
        <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
          <div>
            <h2 className="flex items-center gap-2 text-xl font-semibold"><Wand2 className="h-5 w-5 text-blue-600" />Crear simulación mágica</h2>
            <p className="text-sm text-gray-600">Selecciona el origen de datos para generar la simulación automática.</p>
          </div>
          <Button type="button" variant="outline" onClick={onCancel}><ArrowLeft className="mr-2 h-4 w-4" />Volver</Button>
        </div>
      </div>

      <div className="grid gap-4 lg:grid-cols-2">
        <SourceButton
          icon={ShoppingCart}
          title="Crear a partir de pedidos Dalia-Ennage"
          description="Usa el pendiente de fabricar de la gestión de pedidos compartida, resta stock disponible y crea la simulación por temporada."
          onClick={onSelectSales}
        />
        <SourceButton
          icon={Boxes}
          title="Crear a partir de familia y temporada Alfatex"
          description="Usa artículos del catálogo de fabricación Alfatex y aplica una plantilla común de color y tallas para muestras o revisión posterior."
          onClick={onSelectAlfatex}
        />
      </div>
    </div>
  );
}
